<template>
<div class="mHeader">
    <div class="m-header">
        <div class="appTips" v-show="showAppTips">
            <div class="leftIntroduce">
                <img class="introduceLogo" :src="require('@/common/images/header/introduce_logo.png')" alt="">
                <div class="introduce">
                    <div class="introduceTitle">鲸融网APP</div>
                    <div class="tips">让资本赋能企业成长</div>
                </div>
            </div>
            <div class="rightBtn">
                <a href="https://m.capwhale.com/mapp">立即打开</a>
            </div>
            <img class="close" @click="hideAppTips" :src="require('@/common/images/header/closeAppTips.png')" alt="">
        </div>
        <div class="headerBox">
            <div class="logo">
                <img :src="require('@/common/images/header/new_logo1.png')" alt="">
            </div>
            <!-- <div class="search">
                <form action="/">
                    <van-search v-model.trim="param.key" placeholder="请输入搜索关键词" @search="onSearch"
                                @cancel="onCancel"></van-search>
                </form>
            </div> -->
            <div class="right_box">
                <div class="menu_box" v-if="!isShowMenu">
                    <a href="http://m.capwhale.com/">首页</a>
                    <a href="https://ke.capwhale.com/m/mindex">课堂</a>
                    <a href="http://m.capwhale.com/index/indexn.html">资讯</a>
                    <a href="http://edu.capwhale.com/mzt/sxy/index.shtml">商学院</a>
                </div>
                <div class="show_menu_box" v-else>
                    <!-- <a href="">APP</a> -->
                    <img @click="goLogin" :src="user.isLogin ? (user.logourl ? user.logourl : require('@/common/images/header/user.png')) : require('@/common/images/header/myIcon.svg')" alt="">
                </div>
                <!-- <div class="head_photo">
                    <img :src="require('@/common/images/header/myIcon.svg')" alt="">
                </div> -->
                <div class="menu" @click="openMenu">
                    <img :src="isShowMenu ? require('@/common/images/mindex/icon-close.png') : require('@/common/images/header/homeIcon4.svg')" alt="">
                    <!-- <div class="icon" :class="[isShowMenu?'icon-close':'icon-menu']" ></div> -->
                </div>
            </div>
        </div>
        
        
    </div>
    <transition name="van-slide-down">
        <!-- <MMenu v-if="isShowMenu" @openFollow="openFollow" @openTeamwork="openTeamwork"
               @openUpload="openUpload"></MMenu> -->
        <ChangeMenu :isShowMenu="isShowMenu" v-show="isShowMenu" />
    </transition>
    <Popup :pop="follow" ref="follow"></Popup>
    <Popup :pop="teamwork" ref="teamwork"></Popup>
    <Popup :pop="upload" ref="upload"></Popup>
</div>
</template>

<script>
// import MMenu from 'views/mobile/components/mheader/mMenu'
// import MMenu from 'views/mobile/components/mheader/my.vue'
import ChangeMenu from 'views/mobile/components/mheader/changeMenu1.0.vue'
import Popup from 'views/mobile/components/popup/popup'
import {mapActions, mapGetters} from 'vuex'
export default {
    name: 'mHeader',
    data() {
        return {
            follow: {
                url: require('@/common/images/mindex/img-follow-qrcode.png'),
                title: '',
                tip: ['关注公众号获取更多信息'],
                isSave: true,
                width: '4rem'
            },
            teamwork: {
                url: require('@/common/images/mindex/img-teamwork-qrcode.png'),
                title: '',
                tip: ['开课合作请联系微信客服', '客服电话：13066904312'],
                isSave: true,
                width: '4.2rem'
            },
            upload: {
                url: require('@/common/images/mindex/img-computer.png'),
                title: '',
                tip: ['请在pc端访问网址： ', 'http://czadmin.capwhale.com/login'],
                size: [1.1, 1],
                isSave: false,
                width: '5.4rem'
            },
            param: {
                key: ''
            },
            isShowMenu: false
        }
    },
    methods: {
        openFollow() {
            this.$refs.follow.open()
        },
        openTeamwork() {
            this.$refs.teamwork.open()
        },
        openUpload() {
            this.$refs.upload.open()
        },
        openMenu() {
            this.isShowMenu = !this.isShowMenu
        },
        touchStart(){
            event.preventDefault() //通知 Web 浏览器不要执行与事件关联的默认动作
        },
        onSearch() {
          this.isShowMenu = false
            this.$router.push({name: 'MSearchList', query: {key: encodeURI(this.param.key)}})
            this.setRefresh(true)
        },
        goLogin() {
            if (!this.user.isLogin) {
                this.$router.push({name: 'MLogin'})
            } else {
                this.$router.push({name: 'Mme'})
            }
        },
        hideAppTips() {
            this.setShowAppTips(false)
        },
        onCancel() {

        },
        ...mapActions(['setRefresh', 'setShowAppTips'])
    },
    filters: {},
    watch: {
      isShowMenu: {
        handler (val) {
          if (val) {
            document.body.classList.add('overflow-hidden')
            // document.addEventListener('touchmove', this.touchStart,{passive:false})
            //一般第三个参数可直接填false,true -> 表示在捕获阶段调用事件处理程序, false -> 表示在冒泡阶段调用事件处理程序使用，但是touchmove会被浏览器忽略掉，并不会阻止默认行为，这里通过passive:false明确声明为不是被动的
          } else {
            document.body.classList.remove('overflow-hidden')
            // document.removeEventListener('touchmove',this.touchStart,{passive:false})
          }
        }
      }

    },
    computed: {
        ...mapGetters([
            'user',
            'showAppTips'
        ])
    },
    components: {
        Popup, ChangeMenu
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
.mHeader {
    .m-header{
        background: $c-white;
        position: fixed;
        z-index: 3;
        top:0;
        left:0;
        right:0;
        .appTips {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 1.1rem;
            background: #FAFAFA;
            padding: 0.24rem 0.48rem 0.24rem 0.34rem;
            box-sizing: border-box;
            position: relative;
            .leftIntroduce {
                display: flex;
                align-items: center;
                .introduceLogo {
                    width: 0.62rem;
                    height: 0.62rem;
                    margin-right: 0.2rem;
                }
                .introduce {
                    .introduceTitle {
                        font-size: 0.28rem;
                        color: #333333;
                        font-size: 0.28rem;
                        // line-height: 0.36rem;
                        font-weight: bold;
                    }
                    .tips {
                        font-size: 0.2rem;
                        color: #999999;
                        line-height: 0.28rem;
                    }
                }
            }
            .rightBtn {
                a {
                    display: block;
                    width: 1.5rem;
                    height: 0.52rem;
                    line-height: 0.52rem;
                    background: #1677FF;
                    color: #fff;
                    text-align: center;
                    font-size: 0.28rem;
                    border-radius: 0.04rem;
                }
            }
            .close {
                width: 0.32rem;
                height: 0.32rem;
                position: absolute;
                top: 0;
                right: 0;
            }
        }
        .headerBox {
            height: 0.88rem;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: #fff;
        }
        // box-shadow:0 0.02rem 0.06rem 0 rgba(0,0,0,0.1);
        .logo{
            margin: 0.15rem 0.28rem 0.15rem 0.32rem;
            margin-left: 0.32rem;
            margin-right: 0.28rem;
            width: 2.35rem;
            height: 0.37rem;
            img {
                width: 1.3rem;
                height: 0.37rem;
            }
        }
        .search{
            margin: 0.15rem 0;
            width: 3.6rem;
            height: 0.58rem;
            background: $c-lightGray;
            border-radius: 0.3rem;
            padding: 0 0.1rem 0 0.1rem;
            box-sizing: border-box;
            .van-search{
                padding: 0;
                background: transparent;
                .van-search__content{
                    background: transparent;
                }
                .van-field__body{
                    .van-icon-clear{
                        margin-right: 0.1rem;
                    }
                }
                .van-cell{
                    position: relative;
                    line-height: 1;
                    padding: 0 0.16rem 0 0;
                    .van-field__left-icon{
                        position: absolute;
                        top: 0.14rem;
                        right: 0;
                        margin-right: 0;
                    }
                    .van-field__body{
                        input{
                            padding: 0.1rem 0;
                            box-sizing: border-box;
                            height: 0.6rem;
                            line-height: 0.6rem;
                        }
                    }
                }
            }
        }
        .right_box {
            display: flex;
            align-items: center;
        }
        .menu_box {
            a {
                margin-right: 0.32rem;
                font-size: 0.28rem;
                color: #333333;
            }
        }
        .show_menu_box {
            display: flex;
            align-items: center;
            a {
                font-size: 0.28rem;
                color: #999999;
            }
            img {
                width: 0.51rem;
                height: 0.51rem;
                margin: 0 0.4rem;
                border-radius: 50%;
            }
        }
        .menu{
            img {
                width: 0.32rem;
                height: 0.32rem;
            }
            padding: 0.15rem 0.32rem 0.15rem 0;
            .icon{
                width: 0.36rem;
                height: 0.36rem;
            }
        }

    }
    .slide-sort-enter-active, .slide-sort-leave-active{
        transition: all 0.5s
    }
    .slide-sort-enter, .slide-sort-leave-to{
        transform: translate3d(100%, 0, 0)
    }
}
</style>